import './loaderScreen.css'
import ReactPortal from "../Utils/ReactPortal";

const LoaderScreen = () => {
    const isLoaderPortalEmpty = document.querySelector('#loader-screen').innerHTML === ""
    return (
        <>
            {isLoaderPortalEmpty ?
                <ReactPortal id={'loader-screen'}>
                    <div className={'loader-screen'}>
                        <i className="fas fa-hamburger loader-screen-icon"/>
                    </div>
                </ReactPortal> : ''
            }
        </>

    )
}

export default LoaderScreen;